module.exports = __webpack_public_path__ + "static/media/AwardsProject.7f3a019f.png";